import { render, staticRenderFns } from "./subjects.vue?vue&type=template&id=260fd5d5&scoped=true&"
import script from "./subjects.vue?vue&type=script&lang=js&"
export * from "./subjects.vue?vue&type=script&lang=js&"
import style0 from "./subjects.vue?vue&type=style&index=0&id=260fd5d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260fd5d5",
  null
  
)

export default component.exports